import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { ContextDialog } from '@dreryk/react-components';

import { VisitDetailsFormBean } from '../../../shared/form/visitDetails/visitDetails.types';
import { useVisitSettlementAction } from '../../../shared/useVisitSettlementAction';
import { visitSettlementTranslationKeys } from '../../../translations';

const t = visitSettlementTranslationKeys.extensions.calendar.tab.confirmButton;

type VisitSettlementCalendarTabContextDialogButtonProps = {
   readonly appointmentId: number;
   readonly practitionerId: number;
   readonly ownedByCurrentUser: boolean;
   readonly invoiceProviderIntegrationEnabled: boolean;
   readonly visitSettlement: VisitSettlement | null;
   readonly visitDetails: Omit<VisitDetailsFormBean, 'practitioner'>;
};

export const VisitSettlementCalendarTabContextDialogButton = (
   props: VisitSettlementCalendarTabContextDialogButtonProps
): JSX.Element => {
   const {
      appointmentId,
      ownedByCurrentUser,
      practitionerId,
      visitSettlement,
      visitDetails,
      invoiceProviderIntegrationEnabled,
   } = props;

   const {
      visitSettlementAdjustmentModal,
      visitSettlementPaymentModal,
      disabled,
      label,
      openModal,
   } = useVisitSettlementAction({
      invoiceProviderIntegrationEnabled: invoiceProviderIntegrationEnabled,
      initialVisitSettlement: visitSettlement,
      ownedByCurrentUser: ownedByCurrentUser,
      visitDetails: visitDetails,
      appointmentId: appointmentId,
      practitionerId: practitionerId,
      adjustmentLabel: t.adjustment,
      paymentLabel: t.payment,
   });

   return (
      <>
         <ContextDialog.ConfirmButton label={label} onClick={openModal} disabled={disabled} />
         {visitSettlementPaymentModal}
         {visitSettlementAdjustmentModal}
      </>
   );
};
